var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.048 4.857a6.19 6.19 0 1 0 4.272 10.67 1.5 1.5 0 0 1 .208-.207 6.19 6.19 0 0 0-4.48-10.462m7.328 11.498a9.048 9.048 0 1 0-7.328 3.74 9 9 0 0 0 5.307-1.72l3.206 3.207a1.429 1.429 0 1 0 2.02-2.02z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;